module.exports = __webpack_public_path__ + "media/icons/twitter-white-47178454.png";